import api from './api';

export const getSurveyUser = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: '/surveys/user',
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};

export const getSurveys = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: '/surveys/type/signup',
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};

export const updateSurvey = async (data) => {
  try {
    const response = await api({
      method: 'POST',
      url: '/surveys/type/signup',
      data,
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};
